import { Button } from "@/components/ui/button";
import { useI18n } from "@/hooks/useI18n";
import { useDrawers } from "@/hooks/useDrawers";
import { FileText } from "lucide-react";

export const FloatingCTAs = () => {
  const { t } = useI18n();
  const { openRFQ } = useDrawers();

  const handleRFQClick = () => {
    // Track HubSpot event
    if (window._hsq) {
      window._hsq.push(['trackEvent', { id: 'request_quote_clicked' }]);
    }
    openRFQ();
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Request Quote */}
      <Button
        size="lg"
        className="shadow-andean h-12 px-6 rounded-full"
        onClick={handleRFQClick}
      >
        <FileText className="w-5 h-5 mr-2" />
        {t('cta.quote')}
      </Button>
    </div>
  );
};